module.exports = {
  siteTitle: 'Naveen R | Software Engineer',
  siteDescription:
    'a software engineer based in Bangalore, India who enjoys building things that live on the internet. I develop exceptional Android and web apps Intigrating with AI and Ml that provide intuitive, pixel-perfect user interfaces with efficient and modern backends',
  siteKeywords:
    'Naveen RJ, Naveen, RJ, naveenrj98, software engineer, Android App developer, Reactdeveloper, javascript, Bangalore',
  siteUrl: 'https://github.com/naveenrj98/naveenrj98.github.io',
  siteLanguage: 'en_US',
  googleAnalyticsID: 'UA-45666519-2',
  googleVerification: 'DCl7VAf9tcz6eD9gb67NfkNnJ1PKRNcg8qQiwpbx9Lk',
  name: 'Naveen R',
  location: 'Bangalore, India',
  email: 'naveenjyothiramesh@gmail.com',
  github: 'https://github.com/naveenrj98/',
  twitterHandle: '#',
  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/naveenrj98/',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/naveenr98',
    },
    {
      name: 'Codepen',
      url: 'https://codepen.io/naveenrj98',
    },
    {
      name: 'Twitter',
      url: 'https://twitter.com/NaveenR74420078',
    },
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Experience',
      url: '/#jobs',
    },
    {
      name: 'Work',
      url: '/#projects',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  navHeight: 100,
  greenColor: '#64ffda',
  navyColor: '#0a192f',
  darkNavyColor: '#020c1b',

  srConfig: (delay = 200) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor: 0.25,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
